import { Tooltip } from "@mui/material";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { GetError } from "src/constant";
import { getMyData } from "src/thunks/auth";
import { isDropdownOpenFlag } from "src/thunks/dashboard";
import React from "react";
import _ from "lodash";
import { Search, Close } from "@mui/icons-material";
import "./projectManagerProjectDropdown.scss";


export const ProjectManagerProjectDropdown = ({ handleChange, projectGoodsInDropdownValue, clientId }) => {

    // UseSelector
    const dropdownRef = useRef(null);

    // UseState
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [searchValue, setSearchValue] = useState("");

    // Variable Declarations
    let dataShown = []
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const filteredProjectList = userDetails?.projects.filter(project => project?.clientId === clientId?.id);

    // Use effect
    useEffect(() => {
        dataShown = _.orderBy(filteredProjectList, ['name'], ["asc"])
        setFilteredData([...dataShown])
    }, [clientId])

    useEffect(() => {
        getAllMyData()
    }, [])

    useEffect(() => {
        dispatch(isDropdownOpenFlag(open))
    }, [open])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Functions declarations
    const getAllMyData = async () => {
        try {
            let res = await dispatch(getMyData()).unwrap();
        } catch (err) {
            toast.error(GetError(err?.response?.data?.errors) || "something issue");
        } finally {
        }
    };

    const handleClearSearchText = () => {
        handleSearchInputChange({ target: { value: "" } });
    };

    const handleSearchInputChange = (e) => {
        setSearchValue(e.target.value)
        const searchTerm = e.target.value.toLowerCase();
        if (searchTerm === '') {
            let d = _.orderBy(filteredProjectList, ['name'], ["asc"])
            setFilteredData([...d])
        } else {
            const filtered = filteredData.filter((item) => item.name.toLowerCase().includes(searchTerm));
            let data = _.orderBy(filtered || [], ['name'], ["asc"])
            setFilteredData([...data]);
        }
    };

    const onElementClicked = (item) => {
        handleChange(item);
        setOpen((prevOpen) => !prevOpen);
    };

    const onButton = () => {
        setOpen(!open)
    };

    return (
        <>
            <div ref={dropdownRef}>
                <div className="text-white">
                    <div className="mt-3 mt-sm-0 wrapper-pm-dropdown">
                        <Tooltip
                            title={
                                filteredProjectList?.length > 0 ? (
                                    ""
                                ) : (
                                    <span className="project-dropdown-tooltip-style">
                                        Please select client first
                                    </span>
                                )
                            }
                        >
                            <div
                                className="d-flex flex-row justify-content-between"
                                onClick={() => onButton()}
                            >
                                <Tooltip title={projectGoodsInDropdownValue.name == "ALL PROJECTS" ? "" : <span className="project-dropdown-tooltip-style1 project-dropdown-tooltip-style">{`${projectGoodsInDropdownValue.name || "ALL PROJECTS"}`}</span>} arrow>
                                    <span className="projectname-wrap">
                                        {projectGoodsInDropdownValue.name || "ALL PROJECTS"}
                                    </span>
                                </Tooltip>

                                {open ? (
                                    <span className="pe-2">
                                        <i className="bi bi-chevron-up chevron-up-arrow"></i>
                                    </span>
                                ) : (
                                    <span className="pe-2">
                                        <i className="bi bi-chevron-down chevron-down-arrow"></i>
                                    </span>
                                )}

                            </div>
                        </Tooltip>
                        {(filteredProjectList?.length > 0 && open) && (
                            <>
                                <div className={`content`}>
                                    <div style={{ position: "relative", background: "#0045d9" }}>
                                        <input
                                            style={{ position: "relative", width: "100%" }}
                                            className="search-field-input"
                                            type="text"
                                            placeholder="Search by name..."
                                            value={searchValue}
                                            onChange={handleSearchInputChange}
                                        />
                                        {searchValue !== "" ? (
                                            <Close
                                                style={{ cursor: "pointer" }}
                                                onClick={handleClearSearchText}
                                                className="search-icon-depotpersonal-style"
                                            />
                                        ) : (
                                            <Search className="search-icon-depotpersonal-style" />
                                        )}
                                    </div>

                                    {[{ name: "ALL PROJECTS", value: 0 }, ...filteredData]?.map((item, index) => {
                                        return (
                                            <React.Fragment key={index}>
                                                <div className={projectGoodsInDropdownValue?.name === item.name ? `selected-dropdownfield` : ""}
                                                    onClick={() => onElementClicked(item)}
                                                >
                                                    {item.name}
                                                </div>
                                            </React.Fragment>
                                        );
                                    })}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}